import { dbPost } from '../../../apis/commonApi';

class ExpertAuditDetailController {
  initList = {
    acbg: [],
    crr: [],
    actv: [],
  };

  constructor(
    navigate,
    store,
    modalService,
    validateService,
    { userRole, setRole },
    { valueList, setValueList },
    { trashSeq, setTrash },
    { selectedFiles, setSelectedFiles, setUploadList },
    { statusOption, setStatusOption },
    { rowInfo, setRowInfo }
  ) {
    this.navigate = navigate;
    this.store = store;
    this.modalService = modalService;
    this.validateService = validateService;
    this.userRole = userRole;
    this.setRole = setRole;
    this.valueList = { ...this.initList, ...valueList };
    this.setValueList = setValueList;
    this.trashSeq = trashSeq;
    this.setTrash = setTrash;
    this.selectedFiles = selectedFiles;
    this.setSelectedFiles = setSelectedFiles;
    this.setUploadList = setUploadList;
    this.setStatusOption = setStatusOption;
    this.rowInfo = rowInfo;
    this.setRowInfo = setRowInfo;
  }

  getRole() {
    const role = ['EX', 'ME', 'ADMIN'];
    return role.includes(this.store.authrtId);
  }

  adminElse() {
    const role = this.store.authrtId;
    if (role === 'ADMIN') {
      this.setRole(true);
    } else if (role === 'EX' || role === 'ME') {
      this.setRole(false);
    }
  }

  async fnOption() {
    const code = ['S302', 'S303', 'S304'];
    const url = '/expert-audit/status/list.do';

    const param = {
      code: code,
    };

    let response;

    try {
      response = await dbPost(url, param);
      if (response instanceof Error) {
        this.modalService.errorAlert(
          '데이터 처리중 에러가 발생하였습니다',
          () => {}
        );
      } else {
        const data = response[0];
        this.setStatusOption(data);
      }
    } catch (error) {
      this.modalService.errorAlert(
        '데이터 처리중 에러가 발생하였습니다',
        () => {}
      );
    }
  }

  async fnSearch(entSn) {
    const url = '/expert-audit/detail/list.do';
    const param = {
      entSn: entSn,
    };
    let response;

    try {
      response = await dbPost(url, param);

      if (response[0]) {
        this.setValueList(response[0]);
      }
    } catch (error) {
      this.modalService.errorAlert(
        '데이터 처리중 에러가 발생하였습니다',
        () => {}
      );
    }
  }

  //저장
  async fnSave(status) {
    const url = '/expert-audit/detail/save.do';

    if (status === 'P' && !this.nullCheck(this.valueList)) {
      this.modalService.noticeAlert('모든 항목은 필수로 입력해주세요.');
      return;
    }

    if (this.nullCheck2(this.valueList)) return;

    this.valueList['status'] = status;
    this.valueList['deleteSeq'] = this.trashSeq;

    let response;
    try {
      response = await dbPost(url, this.valueList);
      if (response instanceof Error) {
        this.modalService.errorAlert(
          '데이터 처리중 에러가 발생하였습니다',
          () => {}
        );
      } else {
        if (status === 'W') {
          await this.fnSearch().then(() =>
            this.modalService.successAlert('임시 저장 완료')
          );
        }
        if (status === 'P') {
          this.modalService.successAlert('신청 완료', () => {
            this.navigate('/expert/register/list');
          });
        }
      }
    } catch (error) {
      this.modalService.errorAlert(
        '데이터 처리중 에러가 발생하였습니다',
        () => {}
      );
    }
  }

  nullCheck(list) {
    const item = ['acbg', 'crr', 'actv'];
    return item.every(key => {
      return list[key].every(innerList => {
        return Object.entries(innerList).every(
          ([k, v]) => k === 'atchFileId' || k === 'fileList' || v
        );
      });
    });
  }

  nullCheck2(list) {
    const item = ['acbg', 'crr', 'actv'];
    return item.every(key => {
      return list[key].every(innerList => {
        return Object.entries(innerList).every(
          ([k, v]) =>
            k === 'fileList' || !v || (Array.isArray(v) && v.length === 0)
        );
      });
    });
  }

  async updateStatus(status, rowData, reason) {
    const url = '/expert-audit/detail/update.do';
    const param = {
      entSn: rowData.entSn,
      result: status,
      userNm: rowData.userNm,
      aplyDt: rowData.aplyDt,
    };

    if (status === 'D' && reason) {
      param['reason'] = reason;
    }

    let response;

    try {
      response = await dbPost(url, param);
      if (response instanceof Error) {
        this.modalService.errorAlert(
          '데이터 처리중 에러가 발생하였습니다',
          () => {}
        );
      } else {
        const message = {
          C: '승인되었습니다.',
          D: '반려되었습니다.',
        };
        if (message[status]) {
          this.modalService.successAlert(message[status], () => {
            this.navigate('/expert/register/list');
          });
        }
      }
    } catch (error) {
      this.modalService.errorAlert(
        '데이터 처리중 에러가 발생하였습니다',
        () => {}
      );
    }
  }

  onChange(model, value, setChild) {
    setChild(prev => ({
      ...prev,
      [model]: value,
    }));
  }

  append_btn(part, ChildData, setFocus) {
    this.setValueList({
      ...this.valueList,
      [part]: [...this.valueList[part], ChildData],
    });
    setFocus ? setFocus(true) : '';
  }

  focusData(part, focusInput) {
    const length = this.valueList[part].length - 1;
    focusInput.current[length]?.focus();
  }

  delete_btn(part) {
    if (this.valueList[part].length > 0) {
      let item = 0;
      let list = this.valueList[part];

      const lng = list.length - 1;

      item =
        list[lng].acbgSeq || list[lng].crrMttrSeq || list[lng].actvSeq || item;

      if (item) {
        const param = {
          part: part,
          seq: item,
        };
        this.setTrash(prev => [...prev, param]);
      }

      this.setValueList(prev => ({
        ...prev,
        [part]: prev[part].slice(0, -1),
      }));
    }
  }

  updateList(part, rowIndex, updateItem) {
    this.setValueList(prev => ({
      ...prev,
      [part]: prev[part].map((val, idx) =>
        idx === rowIndex ? updateItem : val
      ),
    }));
  }

  async getFileList(fileId) {
    if (!fileId) return null;

    const url = '/common/file/list.do';
    const param = {
      fileId: fileId,
    };

    let response;

    try {
      response = await dbPost(url, param);
      if (response instanceof Error) {
        this.modalService.errorAlert(
          '데이터 처리중 에러가 발생하였습니다',
          () => {}
        );
      } else {
        if (response.length > 0) {
          response.forEach(item => {
            let file = {};
            file.status = 'Uploaded';
            file.name = item.orgnflNm;
            file.size = Math.round(item.fileSz / 1024);
            file.fileSeq = item.fileSeq;
            file.fileId = item.fileId;
            this.setSelectedFiles(prev => [...prev, file]);
            this.setUploadList(prev => [...prev, file]);
          });
        }
      }
    } catch (error) {
      this.modalService.errorAlert(
        '데이터 처리중 에러가 발생하였습니다',
        () => {}
      );
    }
  }

  settingRowInfo(part, row, rowIndex) {
    this.setRowInfo({
      part: part,
      row: row,
      rowIndex: rowIndex,
    });
  }

  validationDate(value) {
    const date = new Date();
    const formattedDate = `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, '0')}${String(date.getDate()).padStart(2, '0')}`;
    if (value && value > formattedDate) {
      return true;
    }
  }

  async fileIdUpdate() {
    const url = '/expert-audit/file/info/update.do';
    const match = {
      acbg: 'acbgSeq',
      crr: 'crrMttrSeq',
      actv: 'actvSeq',
    };
    const seq = this.rowInfo.row[match[this.rowInfo.part]];

    if (seq) {
      const param = {
        part: this.rowInfo.part,
        seq: seq,
      };

      let response;
      try {
        response = await dbPost(url, param);
        if (response instanceof Error) {
          this.modalService.errorAlert('데이터 처리중 에러가 발생하였습니다');
        }
      } catch (error) {
        this.modalService.errorAlert('데이터 처리중 에러가 발생하였습니다');
      }
    }
  }

  // 파일 다운로드
  async downloadUploadedFile(fileData) {
    const url =
      process.env.REACT_APP_BACKEND_URL + 'files/' + fileData.chgFileNm;
    const res = await fetch(url);
    const arrayBuffer = await res.arrayBuffer();
    const blob = new Blob([arrayBuffer], { type: 'application/octet-stream' });
    const blobURL = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = blobURL;
    a.style.display = 'none';
    a.rel = 'noopener noreferrer';
    a.download = fileData.orgnflNm;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
}

export default ExpertAuditDetailController;
